// src/components/Layout.tsx
import { Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
    const location = useLocation();

    // Hide navbar on ExamsPro page
    const hideNavbarRoutes = ["/solutions/examspro"];
    const shouldHideNavbar = hideNavbarRoutes.some((r) =>
        location.pathname.startsWith(r)
    );

    return (
        <div className="min-h-screen flex flex-col bg-white relative">
            <AnimatePresence mode="wait">
                {!shouldHideNavbar && (
                    <motion.div
                        key="navbar"
                        initial={{ opacity: 0, y: -15 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -15 }}
                        transition={{ duration: 0.3 }}
                        className="z-[200]"
                    >
                        <Navbar />
                    </motion.div>
                )}
            </AnimatePresence>

            {/* ✅ Use Outlet instead of children */}
            <main className="flex-1">
                <Outlet />
            </main>

            <Footer />
        </div>
    );
}
